import { useEffect, useState } from "react";
import {
  Sparkle, Wrench, Bug, Warning, RocketLaunch, Flask, Code, Star, Heart, Lightning, ShieldCheck, Lock, Megaphone, Gift, Leaf, Plant, Gear, PaintBrush,
  MagicWand, ChartLine, Bell, Eye, Trash, ArrowsClockwise, Globe, DeviceMobile, Camera, Flag, CheckCircle, XCircle, Info, Question, Hammer, Package, Users, Lightbulb,
} from "@phosphor-icons/react";
import { api } from "./api";

const data = (p) => p.then((r) => r.data);
export const updatesApi = {
  list: () => data(api.get("/updates")),
  latest: () => data(api.get("/updates/latest")),
  create: (body) => data(api.post("/updates", body)),
  edit: (id, body) => data(api.put(`/updates/${id}`, body)),
  remove: (id) => data(api.delete(`/updates/${id}`)),
  config: () => data(api.get("/updates/config")),
  saveConfig: (body) => data(api.put("/updates/config", body)),
};

export const UPDATE_ICONS = {
  sparkle: [Sparkle, "Sparkle"], wrench: [Wrench, "Wrench"], bug: [Bug, "Bug"], warning: [Warning, "Warning"], rocket: [RocketLaunch, "Rocket"], flask: [Flask, "Flask"],
  code: [Code, "Code"], star: [Star, "Star"], heart: [Heart, "Heart"], lightning: [Lightning, "Lightning"], shield: [ShieldCheck, "Shield"], lock: [Lock, "Lock"],
  megaphone: [Megaphone, "Megaphone"], gift: [Gift, "Gift"], leaf: [Leaf, "Leaf"], plant: [Plant, "Plant"], gear: [Gear, "Gear"], paint: [PaintBrush, "Design"],
  magic: [MagicWand, "Magic"], chart: [ChartLine, "Chart"], bell: [Bell, "Bell"], eye: [Eye, "Eye"], trash: [Trash, "Removed"], sync: [ArrowsClockwise, "Sync"],
  globe: [Globe, "Globe"], mobile: [DeviceMobile, "Mobile"], camera: [Camera, "Camera"], flag: [Flag, "Flag"], check: [CheckCircle, "Check"], x: [XCircle, "Cross"],
  info: [Info, "Info"], question: [Question, "Question"], hammer: [Hammer, "Hammer"], package: [Package, "Package"], users: [Users, "People"], idea: [Lightbulb, "Idea"],
};
export const iconFor = (key) => (UPDATE_ICONS[key] || UPDATE_ICONS.sparkle)[0];
export const PALETTE = ["#30D158", "#0A84FF", "#5E5CE6", "#E8A100", "#FF9F0A", "#FF375F", "#FF453A", "#AF52DE", "#64D2FF", "#A2845E", "#8E8E93", "#1C1C1E"];

let cfgCache = null;
const cfgListeners = new Set();
export const setUpdatesConfig = (cfg) => { cfgCache = cfg; cfgListeners.forEach((f) => f(cfg)); };
export function useUpdatesConfig() {
  const [cfg, setCfg] = useState(cfgCache);
  useEffect(() => {
    cfgListeners.add(setCfg);
    if (!cfgCache) updatesApi.config().then(setUpdatesConfig).catch(() => {});
    return () => cfgListeners.delete(setCfg);
  }, []);
  return cfg;
}

const SEEN = "updates-seen";
const listeners = new Set();
let latest = null;

export const markUpdatesSeen = (at) => {
  if (!at) return;
  localStorage.setItem(SEEN, at);
  listeners.forEach((f) => f());
};

// True when something was posted after this browser last opened the page.
export function useUpdatesDot(enabled) {
  const [, bump] = useState(0);
  useEffect(() => {
    if (!enabled) return undefined;
    const f = () => bump((n) => n + 1);
    listeners.add(f);
    if (latest === null) updatesApi.latest().then((r) => { latest = r.latest || ""; listeners.forEach((g) => g()); }).catch(() => {});
    return () => listeners.delete(f);
  }, [enabled]);
  return !!enabled && !!latest && (localStorage.getItem(SEEN) || "") < latest;
}

export const noteLatest = (at) => { if (at && (!latest || at > latest)) latest = at; };
export const slug = (s) => (s.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "").slice(0, 30) || "type") + "_" + Math.random().toString(36).slice(2, 6);
